import { Component, EventEmitter, HostListener, Input, OnInit } from '@angular/core';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { AuthService, ROLE } from 'src/app/_provider/auth.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { FilesService } from 'src/app/_provider/files.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import { TicketServiceBase } from 'src/app/_provider/tickets/ticketBase.service';

@Component({
    selector: 'drop-zone',
    templateUrl: './drop-zone.component.html',
    styleUrls: ['./drop-zone.component.scss'],
    standalone: false
})
export class DropZoneComponent implements OnInit {

    //Image drag an drop
    public isDrag: boolean = false
    public dropLeave: boolean = false
    private dragCounter: number = -1;
    public dragUpload: boolean = false
    @HostListener('dragover', ["$event"]) onDragOver(evt){
      evt.preventDefault()
    }
    @HostListener('dragenter', ["$event"]) onDragEnter(evt){

      if(!this.generalSrv.activeTicket ||  this.ticketSrv.hasWorkstepContentEditValue) return
      evt?.preventDefault()
      evt?.stopPropagation()
      this.dragCounter++;
      this.isDrag = true
    }
  
    @HostListener('dragleave', ["$event"]) onDragLeave(evt){
      evt.preventDefault()
      evt.stopPropagation()
      this.dragCounter--;
      if (this.dragCounter === 0) { 
        this.dropLeave = true
        this.isDrag = false
        setTimeout(() => {
          this.dropLeave = false
        }, 200);
      }
    }
  
    @HostListener('drop', ["$event"]) async onDrop(evt){

      if(!this.generalSrv.activeTicket ||  this.ticketSrv.hasWorkstepContentEditValue) return
      
      evt.preventDefault()
      evt.stopPropagation()
      this.dragUpload = true
      this.filesSrv.uploadProgress = 0
      this.dragCounter = 0
      const file: File = evt.dataTransfer.files[0]
      const result: HttpFunctionResult<number> = await this.filesSrv.uploadFile(file)
      this.dropLeave = true
      this.isDrag = false
      setTimeout(() => {
        this.dropLeave = false
        this.dragUpload = false
      }, 200);
      if(result.success){
        this.ticketSrv.addFile({
          id: result.data,
          description: file.name,
          type: "Datei"
        })
        await this.feeback.showInformationToast("Die Datei wurde erfolgreich hinzugefügt.")
      }
    }
    @Input() onParentDrop: EventEmitter<any>

  constructor(
    private ticketSrv: TicketEmployee.TicketService,
    public filesSrv: FilesService,
    private feeback: FeedbackService,
    public authSrv: AuthService,
    private generalSrv: GeneralService,
  ) { 
    
  }

  ngOnInit() {
    this.onParentDrop.subscribe((event: any)=>{
      if(!this.isDrag) {
        this.dragCounter = -1
        this.onDragEnter(event)
      }
    })
  }

}
